import React from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import Popup from 'reactjs-popup';
import { withTranslation } from 'react-i18next';
import check from '../../sass/images/icono-check.svg';

// Components
import Template from '../components/Template';
import alert from '../../sass/images/alert/alert.svg';
// helpers
import { patternEmail } from '../helpers';

// Hooks
import useRecoveryPassword from '../hooks/useRecoveryPassword';

function RecoverPassword(props) {
  const { t } = props;
  const { register, handleSubmit, errors } = useForm();
  const { openModal, closeModal, submit, messageError } = useRecoveryPassword();

  return (
    <Template
      component="recoveryPassword"
      type={2}
      classNameContainer="recovery_password"
      className="container_menu background recovery_password"
    >
      <form onSubmit={handleSubmit(submit)}>
        <div className="row">
          <div className="col" />
          <div className="col-sm-12 col-md-6">
            <h1 className="with_sub">{t('restore-password')}</h1>
            <p className="with_sub" style={{ fontSize: '15px' }}>
              {t('send')}
            </p>
            <label
              htmlFor="email"
              className={`col-form-label ${errors.email ? 'error_label' : ''}`}
            >
              *{t('email')}
            </label>
            <input
              type="test"
              className="form-control"
              id="email"
              name="email"
              ref={register({
                required: { value: true, message: t('write-email') },
                pattern: { value: patternEmail, message: t('invalid') },
              })}
            />
            {errors.email && (
              <div className="error_input">
                <p>
                  <img src={alert} alt={t('alt:notification')} /> {errors.email.message}
                </p>
              </div>
            )}
            {messageError !== '' && (
              <div className="error_input">
                <p> {messageError} </p>
              </div>
            )}
            <br />
          </div>
          <div className="col"> </div>
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-sm-12 col-md-6 with_sub">
            <input
              type="submit"
              className="col btn btn-primary send_register send_recovery"
              value={t('enter')}
            />
          </div>
          <div className="col" />
        </div>
      </form>
      {openModal ? (
        <div className="modal-design">
          <Popup open={openModal}>
            <div className="modal-reset">
              <button
                type="button"
                className="close"
                style={{ cursor: 'pointer' }}
                onClick={closeModal}
              >
                &times;
              </button>
              <div className="modal-content">
                <h3 align="center"> {t('restore-password')} </h3>
                <div className="modal-heading-box">
                  <img className="modal-image" src={check} alt={t('alt:successful_process')} />
                </div>
                <div className="modal-form">
                  <div className="modal-img-box">
                    <p>{t('recover')}</p>
                  </div>
                  <button
                    type="button"
                    className="close_modal"
                    style={{ cursor: 'pointer' }}
                    onClick={closeModal}
                  >
                    {t('accept')}
                  </button>
                </div>
              </div>
            </div>
          </Popup>
        </div>
      ) : (
        ''
      )}
    </Template>
  );
}

RecoverPassword.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['login', 'alt'])(RecoverPassword);
